
import ListItem from '@material-ui/core/ListItem';
import { IContactChannels } from 'interface/contactChannels';
import { toastSuccess } from '../../../utils/reduxToast';

const ContactItem = ({contactChannel}: {contactChannel: IContactChannels}) => {
  const openWhatsOrTelegram = () => window.open(`${contactChannel.data}`);
  const openWhatsAppPhone = () => window.open(`https://wa.me/55${contactChannel.data}`);
  const openTelegramPhone = () => console.log('Opção não disponível');
  const copyEmail = () => {
    navigator.clipboard.writeText(contactChannel.data);
    toastSuccess('E-mail copiado!');
  };

  const selectContact = () => {
    const listOfActions = [
      openWhatsAppPhone,
      openTelegramPhone,
      copyEmail,
      openWhatsOrTelegram,
      openWhatsOrTelegram,
      openWhatsOrTelegram,
      () => console.error('Opção não disponível')
    ]
    listOfActions[contactChannel.type] && listOfActions[contactChannel.type]();
  }

  return (
    <ListItem onClick={selectContact}>{contactChannel.icon && <contactChannel.icon />}&nbsp; {contactChannel.name}</ListItem>
  );
}

export default ContactItem;